export default {
  // pageDomain: "http://192.168.3.88",
  // pageDomain: 'http://home.pntao.com',
  pageDomain: 'http://home.qianlaiju.com',

  isAndroid() {
    const u = navigator.userAgent;
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
    return isAndroid
  }
}